import { Link } from "basis";
import { usePageTracking } from "react-event-tracker";
import { SvgInline } from "components/SvgInline/SvgInline";
import { useProfile } from "library/hooks/auth/useProfile";
import styles from "./password-recovery.module.scss";

export const ResetPasswordSuccess = () => {
  const { isLoggedIn } = useProfile();
  usePageTracking({
    page: {
      pageType: "confirmation-page",
      siteSection: "sign-in",
      siteSubSection: "",
      pageTitle: "password-changed",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });
  return (
    <div className={`${styles.resetPasswordWrapper} ${styles.success}`}>
      <h1 className="h4">Your new password has been set</h1>
      <SvgInline name="icon-Tick-Large-Circle" className={styles.check} />
      {!isLoggedIn ? (
        <div className={styles.backToLogin}>
          <Link
            appearance="primary-button"
            variant="blue-button"
            href="/login"
            newTab={false}
          >
            Log in
          </Link>
        </div>
      ) : (
        <div>
          <Link
            appearance="primary-button"
            width="192"
            variant="blue-button"
            href="/"
            newTab={false}
          >
            View accounts
          </Link>
        </div>
      )}
    </div>
  );
};
